
import Vue from 'vue';
import CandidateService, { PredefinedSkill } from '~/services/CandidateService';
import { commonProps } from '~/utils/candidate';
import SkillsModal from '../modals/SkillsModal.vue';
import Card from './Card.vue';

export default Vue.extend({
    name: 'Skills',
    components: {
        Card,
        SkillsModal,
    },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            candidateService: new CandidateService(),

            showModal: false,
            allSkills: [] as PredefinedSkill[],
        };
    },
    mounted() {
        this.loadAllSkills();
    },
    computed: {
        hasNoSkills(): boolean {
            return !this.candidate.skills.length;
        },
        cardTitle(): string {
            return this.hasNoSkills
                ? this.$t('profile.skills.titleWhenEmpty').toString()
                : this.$t('profile.skills.title').toString();
        },
        skills(): string[] {
            return this.candidate.skills
                .reduce<string[]>((acc, skill) => {
                    if (!!skill.skillId) {
                        const predefinedSkill = this.allSkills.find(s => s.id === skill.skillId);
                        if (!!predefinedSkill) acc.push(predefinedSkill.name);
                    } else if (!!skill.customSkillName) acc.push(skill.customSkillName);

                    return acc;
                }, [])
                .sort((a, b) => a.localeCompare(b));
        },
    },
    methods: {
        loadAllSkills() {
            this.candidateService.getAllSkills().then(skills => (this.allSkills = skills));
        },
    },
});
